import { SpcInstance } from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { SpcApiSpecificationsGetRequest } from "@sizlcorp/sizl-api-document/dist/models";

export const SPC_KEY = "spc";

export const spc = createQueryKeys(SPC_KEY, {
  all: null,
  get: (params: SpcApiSpecificationsGetRequest) => {
    const query = { ...params };
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }
    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => SpcInstance.specificationsGet(query),
    };
  },
});
